import React, {useEffect, useState} from 'react';
import LoadingSpinner from "../../../components/Loading/LoadingSpinner";
import Setting from "./Setting";
import {Button, Col, Container, Form, Row} from "react-bootstrap";
import NoElementsAlert from "../../../components/NoElementsAlert";
import {useTranslation} from "react-i18next";
import ConditionalRender from "../../../components/ConditionalRender";
import IconButton from "../../../components/IconButton";
import {faEdit, faPlus, faTrashCan} from "@fortawesome/free-solid-svg-icons";
import Menu from "../../../components/core/Components/Menu/Menu";
import MenuItem from "../../../components/core/Components/Menu/MenuItem";

const SettingsComponent = ({settings, onUpdate, onDelete, onAdd, onEdit, isUpdatingSettings, editable}) => {

    const [currentSettings, setCurrentSettings] = useState(settings)

    const settingConstraints = [
        {
            key: 'GEOFENCE_TRANSACTION_EXTENSION_PERIOD',
            maxValue: 1200
        }
    ]

    useEffect(() => {
        setCurrentSettings(settings)
    }, [settings]);

    const {t} = useTranslation()

    function handleSettingChange(key, value, valid) {
        setCurrentSettings(prev => prev.map(setting => {
            if (setting.key === key)
            {
                setting.value = value
                setting.valid = valid ?? true
            }

            return setting
        }))

    }

    async function updateSettings(e)
    {
        e.preventDefault()
        // onUpdate(currentSettings.map(s => ({key: s.key, value: s.value, type: s.type})))
        onUpdate(currentSettings)
    }

    const constraintFailed = currentSettings.some(s => s.valid === false)

    if(!settings)
    {
        return <LoadingSpinner className='mt-2'/>
    }


    const knoxDependentKeys = [
        "APP_UNINSTALL_KNOX",
        "ENABLE_LOCATION_KNOX",
        "FORCE_STOP_KNOX"
        // ,
        // "LOCK_LOCATION_KNOX"
    ];

    const enforceKnox = currentSettings.find(s => s.key === "ENFORCE_KNOX");
    const knoxChildren = currentSettings.filter(s => knoxDependentKeys.includes(s.key));
    const otherSettings = currentSettings.filter(s =>
        s.key !== "ENFORCE_KNOX" && !knoxDependentKeys.includes(s.key)
    );

    const knoxChildrenGrayStyle = enforceKnox?.value ? {} : { opacity: 0.5 };

    return (
        <Container className='mt-4'>
            <Form onSubmit={updateSettings}>
                {enforceKnox && (
                    <React.Fragment key="ENFORCE_KNOX">
                        <div className="d-flex align-items-center justify-content-between">
                            <Setting
                                setting={{
                                    ...enforceKnox
                                }}
                                onChange={handleSettingChange}
                            />

                            <ConditionalRender condition={editable}>
                                <div className="ms-3">
                                    <Menu placement="left">
                                        <MenuItem icon={faEdit} text={t('global.operations.edit')}
                                            onClick={() => onEdit && onEdit("ENFORCE_KNOX")} />
                                        <MenuItem icon={faTrashCan} variant="danger"
                                            onClick={() => onDelete && onDelete("ENFORCE_KNOX")}>
                                            {t('global.operations.delete')}
                                        </MenuItem>
                                    </Menu>
                                </div>
                            </ConditionalRender>
                        </div>
                        <hr />
                    </React.Fragment>
                )}
                {knoxChildren.length > 0 && (
                    <div style={{ marginLeft: "30px", ...knoxChildrenGrayStyle }}>
                        {knoxChildren.map(setting => (
                            <React.Fragment key={setting.key}>
                                <div className="d-flex align-items-center justify-content-between">
                                    <Setting
                                        setting={setting}
                                        onChange={handleSettingChange}
                                        constraints={settingConstraints.find(c => c.key === setting.key)}
                                    />

                                    <ConditionalRender condition={editable}>
                                        <div className="ms-3">
                                            <Menu placement="left">
                                                <MenuItem icon={faEdit}
                                                    text={t('global.operations.edit')}
                                                    onClick={() => onEdit && onEdit(setting.key)} />
                                                <MenuItem icon={faTrashCan}
                                                    variant="danger"
                                                    onClick={() => onDelete && onDelete(setting.key)}>
                                                    {t('global.operations.delete')}
                                                </MenuItem>
                                            </Menu>
                                        </div>
                                    </ConditionalRender>
                                </div>
                                <hr />
                            </React.Fragment>
                        ))}
                    </div>
                )}
                {otherSettings.map(setting => (
                    <React.Fragment key={setting.key}>
                        <div className="d-flex align-items-center justify-content-between">
                            <Setting
                                setting={setting}
                                onChange={handleSettingChange}
                                constraints={settingConstraints.find(c => c.key === setting.key)}
                            />

                            <ConditionalRender condition={editable}>
                                <div className="ms-3">
                                    <Menu placement="left">
                                        <MenuItem icon={faEdit}
                                            text={t('global.operations.edit')}
                                            onClick={() => onEdit && onEdit(setting.key)} />
                                        <MenuItem icon={faTrashCan}
                                            variant="danger"
                                            onClick={() => onDelete && onDelete(setting.key)}>
                                            {t('global.operations.delete')}
                                        </MenuItem>
                                    </Menu>
                                </div>
                            </ConditionalRender>
                        </div>
                        <hr />
                    </React.Fragment>
                ))}
                <ConditionalRender condition={editable}>
                    <div className={'d-flex justify-content-center align-items-center'}>
                        <IconButton icon={faPlus} color={'white'} bg={'green'} onClick={onAdd} />
                    </div>
                </ConditionalRender>
                {/*Display alert in case no settings are present.*/}
                <NoElementsAlert show={settings.length < 1} text={t('pages.settings.noSettingsFound')}/>
                <Row className={'justify-content-center mt-5'}>
                    <Col sm={4} className={'d-flex justify-content-center'}>
                        <ConditionalRender condition={settings.length > 0}>
                            {
                                isUpdatingSettings ?
                                    <LoadingSpinner variant={'success'} small text={"Saving"} className={'my-2'}/> :
                                    <Button disabled={constraintFailed} variant={"success"} className={'w-50 my-2'} type={'submit'}>{t('global.operations.save')}</Button>
                            }
                        </ConditionalRender>
                    </Col>
                </Row>
            </Form>
        </Container>
    );
};

export default SettingsComponent;